<template>
    <div class="fee-summary w-full d-flex mt-2">
        <AonCol v-for="item in feeSummaryData" class="aon-col-6 pl-0">
            <AonCard :title="item?.title">
                <div class="card-content">
                    <p
                        v-if="item.filterRange"
                        class="small link filter-link"
                        @click="sendFilters(item.prune)"
                    >
                        View Patents
                    </p>
                    <h5 :class="`${item?.color}--text`">
                        {{ item?.color === 'error' ? '-' : '' }}${{ item?.value.toLocaleString() }}
                    </h5>
                    <p class="bold small mt-2">{{ item?.scope }}</p>
                </div>
            </AonCard>
        </AonCol>
        <AonCol class="aon-col-6 pl-0">
            <AonCard title="Estimated Fees Pruned">
                <div class="card-content">
                    <p class="small link filter-link" @click="sendFilters(true)">View Patents</p>
                    <div style="display: inline-flex">
                        <h5 :class="`success--text`">
                            ${{ (props.data.totalFeesPruned ?? 0).toLocaleString() }}
                        </h5>
                        <p class="bold small ml-2 mt-2">
                            {{
                                ` savings between ${filters.toUTCString(portfolioManagerStore.dateRange[0])} and ${filters.toUTCString(portfolioManagerStore.dateRange[1])}`
                            }}
                        </p>
                    </div>
                    <br />
                    <div style="display: inline-flex">
                        <h5 :class="`success--text`">
                            ${{ (props.data.futureSavings ?? 0).toLocaleString() }}
                        </h5>
                        <p class="bold small ml-2 mt-2">
                            {{
                                ` future savings after ${filters.toUTCString(portfolioManagerStore.dateRange[1])}`
                            }}
                        </p>
                    </div>
                </div>
            </AonCard>
        </AonCol>
    </div>
</template>

<script setup>
import { computed, inject, ref, watchEffect } from 'vue'
import { usePortfolioManagerStore } from '@/stores'

const portfolioManagerStore = usePortfolioManagerStore()

const filters = inject('filters')

const emit = defineEmits(['send-filters'])
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
})

const feeSummaryData = computed(() => {
    if (!props.data) return []
    return [
        {
            title: 'Estimated Upcoming Patent Fees',
            value: props.data.upcomingFees ?? 0,
            color: 'error',
            scope: `Due from ${filters.toUTCString(portfolioManagerStore.dateRange[0])} to ${filters.toUTCString(portfolioManagerStore.dateRange[1])}`,
            filterRange: true,
            prune: 'false',
        },
    ]
})

const sendFilters = (prune) => {
    emit('send-filters', {
        dateRange: {
            from: portfolioManagerStore.dateRange[0],
            to: portfolioManagerStore.dateRange[1],
        },
        prune: {
            value: prune, //string for ag-grid
        },
    })
}
</script>

<style lang="scss" scoped>
.fee-summary {
    width: 100%;

    .card-content {
        position: relative;
    }

    .filter-link {
        position: absolute;
        top: -40px;
        right: -0px;
    }
    .flex-container {
        display: flex;
        align-items: center; /* Aligns items vertically in the center */
    }
}
</style>
